// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0


export const defaultHooks = (_config?: { name: string }) => ({
  preInsert: (doc: Record<string, unknown>) => {
    const nowUtc = new Date().toISOString();
    if (!doc.createdAt) doc.createdAt = nowUtc;
    if (!doc.updatedAt) doc.updatedAt = nowUtc;
    return doc;
  },
  preSave: (doc: Record<string, unknown>, oldDoc: Record<string, unknown>) => {
    const nowUtc = new Date().toISOString();
    doc.updatedAt = nowUtc;
    if (oldDoc && oldDoc.createdAt) {
      doc.createdAt = oldDoc.createdAt; // Preserve original creation time
    }
    return doc;
  },
});